import createWorkerMiddleware from './createWorkerMiddleware';
import Worker from '../Workers/AssetPollingWorker/assetPolling.worker';

const POLL_RECORDING_STATUS = 'POLL_RECORDING_STATUS';
const worker = new Worker();
const assetPollingWorkerMiddleware = createWorkerMiddleware(worker, POLL_RECORDING_STATUS);

export default assetPollingWorkerMiddleware;
